// assets
import { Story, BoxAdd, Box1, DollarSquare, BoxTime, Calculator, Candle, Graph, Bank, Activity, Task } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  widgets: Story,
  list: Box1,
  prices: DollarSquare,
  create: BoxAdd,
  live: BoxTime,
  calculator: Calculator,
  historicData: Candle,
  strategies: Graph,
  brokers: Bank,
  recommendationTrades: Activity,
  recommendationList: Task
};

// ==============================|| MENU ITEMS - SIMULATION ||============================== //
// TODO: fix translation error=> remove other languages
const backtestingSimulations: NavItemType = {
  id: 'backtesing-simulation',
  title: 'Back-Testing',
  icon: icons.widgets,
  type: 'group',
  children: [
    {
      id: 'list-simulations',
      title: 'Back-Testing',
      type: 'item',
      url: '/simulations',
      breadcrumbs: true,
      icon: icons.list
    },
    {
      id: 'historic-data',
      title: 'Historic Data',
      type: 'item',
      url: '/historic-data',
      breadcrumbs: true,
      icon: icons.historicData
    }
  ]
};

export default backtestingSimulations;
